var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("input", {
        attrs: {
          type: "radio",
          name: _vm.auspraegung.name,
          id: _vm.identifier,
        },
        domProps: { value: _vm.identifier, checked: _vm.isCurrentSelection() },
        on: {
          change: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "label-aligned font-weight-bold",
          attrs: { for: _vm.identifier },
        },
        [
          _c("span", { staticClass: "mainlabel" }, [
            _vm._v(_vm._s(_vm.auspraegung.name)),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "font-weight-light d-block@until-large text-small@until-medium",
            },
            [_vm._v(_vm._s(_vm.getPostage()))]
          ),
          _vm._v(" "),
          _vm.tooltip
            ? _c("Tooltip", { attrs: { infoText: _vm.tooltip } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.getSubtype() == _vm.SUBTYPE_VERSANDAUFTEILUNG &&
      _vm.isCurrentSelection()
        ? [
            _c("VersandaufteilungOverlay", {
              attrs: {
                isCheckout: false,
                auspraegungen: _vm.option.auspraegungen,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }